import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { MainService } from '../main.service';
import { HomeService } from '../home/home.service';
import { Release } from '../home/release';
import { AuthService } from '../auth.service';
import { ReleaseBundleService } from '../release-bundle/release-bundle.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { environment } from '../../environments/environment';

import introJs from 'intro.js/intro.js';

import { ConfirmationService, MenuItem } from 'primeng/primeng';
import { AddComponentsToBundleComponent } from '../shared/add-components-to-bundle/add-components-to-bundle.component';

import { MatDialog } from '@angular/material';

declare var require: any;

const ZipDownloadURL = environment.zipDownloadURL;

@Component({
  selector: 'app-release-bundle',
  templateUrl: './release-bundle.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../../style.scss',
    './release-bundle.component.css']
})
export class ReleaseBundleComponent implements OnInit {
  responce: any;
  msgs: any[];
  releaseBundleForm: any;

  // fromDate: Date = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
  // toDate: Date = new Date();
  fromDate: Date = localStorage.getItem("rbFromDate") ? new Date(JSON.parse(localStorage.getItem("rbFromDate"))) : new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
  toDate: Date = localStorage.getItem("rbToDate") ? new Date(JSON.parse(localStorage.getItem("rbToDate"))) : new Date();
  formatFromDate;
  formatToDate;
  fdMonth;
  toMonth;

  options: {};
  bundleOptions: {};
  bundleDataOptions: {};
  dataOptions: {};
  downloadOptions: {};
  versionOptions: {};
  discardOptions: {};
  releaseBundleList: any[];
  releaseBundle: any;
  releaseBundleProject: any;
  releaseBundleProjectID: any;
  releaseBundleID: any;
  isBundle: boolean = false;
  releaseData: Release[];
  releaseVersionData: any[];
  bundleData: any[];
  selectedRelease;
  selectedReleases = [];
  isClient: boolean;
  items: MenuItem[];
  passedBundle: any;


  userEmail = localStorage.getItem('userEmail');
  userName = localStorage.getItem('userName');
  isTour = localStorage.getItem('isTour');
  is_Admin = localStorage.getItem('is_Admin');
  selectedBundleName: string = localStorage.getItem("rbBundle") ? localStorage.getItem("rbBundle") : "";
  selectedProject: string = localStorage.getItem("rbProject") ? localStorage.getItem("rbProject") : "";
  global: any;

  loading: boolean;

  constructor(private fb: FormBuilder,
    private bundleService: ReleaseBundleService,
    private mainService: MainService,
    private homeService: HomeService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private router: Router,
    public dialog: MatDialog) { }

  getReleaseBundle() {

    this.releaseBundleList = [];

    this.loading = true;

    this.fdMonth = (this.fromDate.getMonth() + 1);
    this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();

    this.toMonth = (this.toDate.getMonth() + 1);
    this.formatToDate = this.toDate.getDate() + '/' + this.toMonth + '/' + this.toDate.getFullYear();


    localStorage.setItem("rbFromDate", JSON.stringify(this.fromDate));
    localStorage.setItem("rbToDate", JSON.stringify(this.toDate));

    if (this.selectedBundleName != "") {
      localStorage.setItem("rbBundle", this.selectedBundleName);
    } else {
      localStorage.setItem("rbBundle", "");
    }

    if (this.selectedProject != "") {
      localStorage.setItem("rbProject", this.selectedProject);
    } else {
      localStorage.setItem("rbProject", "");
    }

    this.bundleDataOptions = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      p: this.selectedProject ? this.selectedProject : '',
      b: this.selectedBundleName ? this.selectedBundleName : '',
      user: this.userEmail ? this.userEmail : ''
    };

    this.mainService.getReleaseBundles(this.bundleDataOptions).then(releaseBundle => {

      if (releaseBundle.length != undefined) {
        this.releaseBundleList = releaseBundle;
        this.loading = false;
      }

    });

  }

  getReleaseData() {
    this.releaseData = [];
    this.homeService.getReleaseData(this.options).then(release => {

      if (release.length != undefined) {
        this.releaseData = release;
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });
  }


  logout() {
    this.authService.logout();
    this.router.navigate(['/Login']);

  }

  lookupRowStyleClass(rowData: any) {
    return rowData.status == 'Discarded' ? 'rowSelected' : '';
  }

  getBundleDownloadData(bundleData) {
    console.log("getbundleDownloadData", bundleData.id);
    this.dataOptions = {
      bundle_id: bundleData.id
    };


    this.bundleData = [];
    this.homeService.getBundleDownloadData(this.dataOptions).then(bundle => {

      if (bundle.length != undefined) {
        this.bundleData = bundle;
        this.getArchiveURL(this.bundleData);
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });


  }

  getArchiveURL(archiveData) {

    var locations;
    var file;

    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Zipping the bundle', detail: " This may take around 1 min ;)", life: 60000 });

    for (var i = 0; i < archiveData.length; i++) {
      if (locations != undefined && file != undefined) {
        locations = locations + ',' + archiveData[i].location;
        file = file + ',' + archiveData[i].file;
      } else {
        locations = archiveData[0].location;
        file = archiveData[0].file;
      }

    }

    this.dataOptions = {
      locationList: locations,
      fileList: file,
      bundle_name: archiveData[0].bundle_name
    };

    this.homeService.getArchiveDownloadURL(this.dataOptions).then(res => {
      if (res.length != undefined) {
        this.getArchive(res[0].zip);
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });
  }

  getArchive(URL) {
    this.downloadOptions = {
      locaction: URL
    };

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;

      this.getZipDownload();
    });
  }

  getZipDownload() {

    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Downloading.....' });
    setTimeout(() => {
      window.location.href = ZipDownloadURL;
    },
      1000);

  }

  getVersionForBundle(bundle) {

    this.passedBundle = bundle;
    this.releaseBundle = bundle.name;
    this.releaseBundleProject = bundle.project;
    this.releaseBundleProjectID = bundle.project_id;
    this.releaseBundleID = bundle.id;
    this.isBundle = true;

    console.log("bundle Id from getversionforbundle", this.releaseBundleID);
    this.fdMonth = (this.fromDate.getMonth() + 1);
    this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();

    this.toMonth = (this.toDate.getMonth() + 1);
    this.formatToDate = this.toDate.getDate() + '/' + this.toMonth + '/' + this.toDate.getFullYear();

    this.options = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      p: this.releaseBundleProject,
      c: '',
      pList: '',
      cList: '',
      workflow: ''
    };

  }

  // release bundle search 
  searchEventHandler(event) {
    if (event.keyCode == 13) {
      this.search();
    }
  }

  checkClient() {
    this.isClient = this.userEmail.includes("@");
  }

  search() {
    this.getReleaseBundle();
  }

  resetMain() {

    this.selectedBundleName = '';
    this.selectedProject = '';
    if (this.global != null) {
      this.global = null;
      this.getReleaseBundle();
    } else {
      this.global = null;
    }
  }

  confirmDiscard(b: any) {
    if (b.created_by == this.userName || this.is_Admin == '1') {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to discard this release bundle?',
        accept: () => {
          this.discardBundle(b);
        },
        reject: () => {
          this.msgs = [];
          this.msgs = [{ severity: 'info', summary: 'Request cancelled' }];
        }
      });
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Discard Bundle', detail: 'No Permission' });
    }

  }

  discardBundle(b: any) {

    this.discardOptions = {
      id: b.id
    };

    this.bundleService.discardBundle(this.discardOptions).then(discard => {
      this.responce = discard.status;
      this.msgs = [];
      this.msgs = [{ severity: 'success', summary: 'Bundle Discarded' }];

      setTimeout(() => {
        this.getReleaseBundle();
      }, 500);


    });
  }

  ondialogClosed(message: boolean): void {
    this.isBundle = message;
  }

  addComponents(passedBundle) {
    const dialogRef = this.dialog.open(AddComponentsToBundleComponent, {
      width: '900px',
      data: passedBundle
    });
  }

  getBundleData(data) {
    this.passedBundle = data;
  }


  ngOnInit() {

    localStorage.removeItem('previousURL');

    if (RegExp('intro', 'gi').test(window.location.search)) {
      introJs().setOptions({
        'doneLabel': '<span style="color: green; font-weight:bold;">Done</span>',
        'keyboardNavigation': 'false',
        steps: [{
          element: '#stepB1',
          intro: 'Latest Release Bundle Details are Displayed. ',
          position: 'top'
        },
        {
          element: '#stepB2',
          intro: 'Thank you for your time <i class="fa fa-heart" style="color:red"></i>',
          position: 'top'
        }
        ]
      })
        .start();
    }

    this.getReleaseBundle();

    this.checkClient();

    this.releaseBundleForm = this.fb.group({
      bundle: ['', Validators.required],
    });

    this.releaseBundleForm.get('bundle').valueChanges.subscribe(bundle => {
      if (bundle != undefined) {

        this.releaseBundle = bundle.name;
        this.releaseBundleProject = bundle.project;
        this.releaseBundleProjectID = bundle.project_id;
        this.releaseBundleID = bundle.id;
        this.isBundle = true;

        this.fdMonth = (this.fromDate.getMonth() + 1);
        this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();
        this.toMonth = (this.toDate.getMonth() + 1);
        this.formatToDate = this.toDate.getDate() + '/' + this.toMonth + '/' + this.toDate.getFullYear();

        this.options = {
          fd: this.formatFromDate,
          td: this.formatToDate,
          p: this.releaseBundleProject,
          c: '',
          pList: '',
          cList: '',
          workflow: '',
          release_id: ''
        };

        this.getReleaseData();
      }
    })

    this.items = [
      {
        label: ' Components', icon: 'fa-plus-square', command: () => {
          this.addComponents(this.passedBundle);
        }
      }
    ];
  }

  rowDblClick(event) {
    this.router.navigate(['/bundle/' + event.data.id]);
  }

}
